import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import { Phase, PHASE_TYPES, PhaseType } from '@schema/phase'
import { initiativeCreationSteps } from '../../shared/workflow'
import { PhaseCard } from '../blocks/PhaseCard'
import { CreationGuide } from '../blocks/CreationGuide'
import { useQuery } from '@based/sdk'

const phaseIcons: Record<PhaseType, string> = {
  idea: '💡',
  location: '📍',
  design: '🗂️',
  construction: '🧱',
  living: '🛋️',
}

export const PhaseSelectionStep = ({
  selectedPhaseType,
  setSelectedPhase,
}: {
  selectedPhaseType: PhaseType
  setSelectedPhase: ({ id, type }: { id: number; type: PhaseType }) => void
}) => {
  const translations = useTranslations().app.dashboard.initiative.creation
  const phasesQuery: { loading: boolean; data?: Phase[] } =
    useQuery('list-phase')
  const phases = Object.fromEntries(
    phasesQuery.data?.map((phase) => [phase.phaseType, phase.id]) ?? [],
  )

  return (
    <CreationGuide
      selectedPhaseType={selectedPhaseType}
      currentStep={initiativeCreationSteps.phaseSelection}
    >
      <Column alignItems="stretch" style={{ flex: '1 0 30rem' }}>
        {Object.values(PHASE_TYPES).map((type, index) => {
          return (
            <PhaseCard
              key={index}
              icon={phaseIcons[type]}
              title={translations.initiativePhaseNames[type]}
              description={translations.initiativePhaseDescriptions[type]}
              selected={type === selectedPhaseType}
              onClick={() => {
                if (phases[type]) {
                  setSelectedPhase({ id: phases[type], type })
                }
              }}
            />
          )
        })}
      </Column>
    </CreationGuide>
  )
}
